/* eslint-disable react/prop-types */
import React from 'react'
import Skeleton from '@mui/material/Skeleton'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import { Theme } from '@mui/material/styles'

type MikeTheme = Theme & {
  palette: Theme['palette'] & {
    lightGrey?: { main: string }
    mediumGrey?: { main: string }
  }
}

interface IProps {
  count?: number
  width?: number
  height?: number
}

const StyledContainer = styled(Grid)(({ theme }) => {
  const t = theme as MikeTheme
  return {
    padding: theme.spacing(6),
    backgroundColor: t.palette.lightGrey?.main,
    border: '1px solid ' + t.palette.mediumGrey?.main
  }
})

const StyledItem = styled(Grid)(({ theme }) => ({
  paddingRight: theme.spacing(6)
}))

const AppsSkeleton = (props: IProps) => {
  const { count = 3, width = 80, height = 80 } = props
  return (
    <StyledContainer
      container
      direction="row"
      alignItems="flex-end"
      justifyContent="flex-start"
    >
      {Array.from(new Array(count)).map((item, key) => (
        <StyledItem item key={key}>
          <Skeleton variant="rectangular" width={width} height={height} />
          <Skeleton variant="text" />
        </StyledItem>
      ))}
    </StyledContainer>
  )
}

export default AppsSkeleton
